module.exports = __webpack_public_path__ + "img/statisticalAnalysis.d4cab68b.png";